import React from 'react';
import { Box, Copy, RadioButton } from '@honda-canada/design-system-react';
import { useTranslation } from 'react-i18next';
import PaymentCalculator from '../PaymentCalculator';
import themeStyles from './PaymentCompareModal.styles';
const SectionRadioContent = themeStyles.apply(Box, 'SectionRadioContent');
const SectionRadio = themeStyles.apply(Box, 'SectionRadio');
const CompareSection = ({ id, isSelected, onSelect }) => {
    const { t } = useTranslation();
    return (React.createElement(SectionRadioContent, { selected: isSelected, "data-testid": "cy-payment-compare-modal-section-content" },
        React.createElement(SectionRadio, { onClick: onSelect, "data-testid": "cy-payment-compare-modal-section-content-radio" },
            React.createElement(RadioButton, { checked: isSelected, value: id, defaultChecked: isSelected }),
            React.createElement(Copy, null, isSelected ? t('Pages.Bap.selectedRadioLabel') : t('Pages.Bap.selectRadioLabel'))),
        React.createElement(PaymentCalculator, { id: id, isCompareSection: true })));
};
export default CompareSection;
